var map = {
	"./industrial-1.jpg": 21568,
	"./industrial-10.jpg": 54990,
	"./industrial-11.jpg": 10664,
	"./industrial-2.jpg": 63238,
	"./industrial-3.jpg": 47037,
	"./industrial-4.jpg": 70168,
	"./industrial-5.jpg": 85146,
	"./industrial-6.jpg": 80059,
	"./industrial-7.jpg": 38654,
	"./industrial-8.jpg": 10381,
	"./industrial-9.jpg": 50501
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 74261;